import { Component, Input } from '@angular/core';
import { formatDate, formatRupiah } from 'apps/admin-web/src/app/shared/utils';

@Component({
  selector: 'app-transaction-card',
  templateUrl: 'transaction-card.component.html',
  styleUrls: ['./transaction-card.component.scss']
})
export class TransactionCardComponent {
  @Input() data: any;

  formatRupiah = formatRupiah;
  formatDate = formatDate;

  getStatusColor(status: string) {
    const normalizedStatus = status.toLowerCase();

    if (normalizedStatus == 'pending') return 'warning';
    if (normalizedStatus == 'success') return 'success';
    if (normalizedStatus == 'rejected') return 'danger';
  }

  iconMap = {
    WITHDRAW: {
      src: '../../../../assets/img/icons/withdraw.svg',
      alt: 'withdraw',
      label: 'Withdraw',
    },
    PROFIT_SHARING: {
      src: '../../../../assets/img/icons/top-up.svg',
      alt: 'profit-sharing',
      label: 'Profit Sharing',
    },
    TOP_UP: {
      src: '../../../../assets/img/icons/top-up.svg',
      alt: 'top-up',
      label: 'Top-Up',
    },
    MEMBERSHIP_PAYMENT: {
      src: '../../../../assets/img/icons/top-up.svg',
      alt: 'membership-payment',
      label: 'Membership Payment',
    },
  };

  get transactionDisplay() {
    const key = this.data.transactionCategoryId.categoryName;
    return this.iconMap[key] || this.iconMap.TOP_UP;
  }
}
